export enum FileExtensionEnum {
    Pdf = 'pdf',
    Png = 'png',
    Jpg = 'jpg',
    Jpeg = 'jpeg',
    HTML = 'html'
}
